import { render, staticRenderFns } from "./Rgpd.vue?vue&type=template&id=c4038dfe&"
import script from "./Rgpd.vue?vue&type=script&lang=js&"
export * from "./Rgpd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports